import type { EventId } from '@atlassian/jira-forge-ui-types/src/common/types/analytics.tsx';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { OPERATIONAL_ACTIONS } from '../../../constants.tsx';
import { fireOperationalEvent } from '../consumers/index.tsx';

export const fireOperationalFailedEvent = ({
	eventId,
	attributes,
}: {
	eventId: EventId;
	attributes?: Attributes;
}) => {
	fireOperationalEvent(OPERATIONAL_ACTIONS.FAILED, {
		id: eventId,
		attributes,
	});
};
